/**
 * VendorCatalog.jsx — Iter 50.  Wraps the shared CatalogPicker as a dedicated
 * sub-screen for the vendor sidebar shell.
 */
import React from 'react';
import CatalogPicker from '../../components/CatalogPicker';

const VendorCatalog = ({ vendor, accent }) => (
  <div className="p-4 sm:p-6 lg:p-8 max-w-[1280px] mx-auto" data-testid="vendor-catalog-screen">
    <div className="mb-6">
      <div className="text-[10px] uppercase tracking-[0.2em] font-bold mb-2" style={{ color: accent }}>Catalog</div>
      <h1 className="text-3xl font-heading font-bold text-text-primary leading-[1.05] mb-2" style={{ letterSpacing: '-0.02em' }}>My offerings</h1>
      <p className="text-sm text-text-secondary">Pick products from the master catalog and set your pricing &amp; terms. Founders browse by these exact product names.</p>
    </div>

    <div className="bg-surface border border-border rounded-2xl p-5" data-testid="vendor-catalog-section">
      <CatalogPicker
        category={vendor.vendor_type}
        accent={accent}
        listEndpoint="/vendor/me"
        saveEndpoint="/vendor/me/catalog-offerings"
        parentKey="vendor"
      />
    </div>
  </div>
);

export default VendorCatalog;
